import { FunctionComponent } from 'react';
import { FeedCardAdmin } from '../../components';
import { TagsFeedCommon } from '../../shared';

export const TagsFeedAdmin: FunctionComponent = () => {
  return <TagsFeedCommon cardComponent={(card) => <FeedCardAdmin card={card} />} />;
};
